import React from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';
import { Typography, Icon } from '@americanexpress/aqx-components';
import { StrikethroughOffer } from 'src/universal/components/Strikethrough';
import {
  getOfferContent,
  getOfferBadgeText,
  getLtoEnabledOfferBadgeText
} from './redux';
import styles from './__styles__/index.scss?modules';

const DualOfferSeparator = () => (
  <div className={styles.slantedSeparatorContainer}>
    <div className={styles.slantedSeparator} />
    <Icon
      className={styles.slantedSeparatorIcon}
      directory="dls"
      imageName="dls-icon-plus-filled"
    />
  </div>
);

const OfferBox = ({
  offerContent = {},
  offerBadgeText,
  ltoOfferBadgeText = '',
  isForHero = false,
  shouldShowLTO = true
}) => {
  const {
    offerHeader,
    offerDescription,
    dualOfferHeader,
    dualOfferDescription
  } = offerContent;

  if (!offerHeader) return null;

  const hasBadgeText = !!ltoOfferBadgeText || !!offerBadgeText;

  return (
    <div
      className={clsx(styles.offerBoxContainer, {
        [styles.isForHero]: isForHero,
        [styles.hasDualOffer]: !!dualOfferHeader
      })}
    >
      <>
        <div
          className={clsx(styles.topOffer, {
            [styles.hasBadge]: hasBadgeText
          })}
        >
          {hasBadgeText && (
            <div className={styles.offerBadge}>
              {shouldShowLTO ? ltoOfferBadgeText : offerBadgeText}
            </div>
          )}
          <StrikethroughOffer
            className={styles.header}
            header={offerHeader}
            Component="h2"
          />
          {offerDescription && (
            <Typography
              className={clsx(styles.description, {
                [styles.hasBadgeText]: hasBadgeText
              })}
            >
              {offerDescription}
            </Typography>
          )}
        </div>
        {dualOfferHeader && <DualOfferSeparator />}
        <div
          className={clsx(styles.bottomOffer, {
            [styles.hasBadgeText]: hasBadgeText,
            [styles.dualOffer]: dualOfferHeader
          })}
        >
          <StrikethroughOffer
            header={dualOfferHeader}
            Component="h2"
            className={styles.header}
          />
          {dualOfferDescription && (
            <Typography className={styles.description}>
              {dualOfferDescription}
            </Typography>
          )}
        </div>
      </>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  const { shortName } = ownProps || {};
  return {
    offerContent: getOfferContent(state, shortName),
    ltoOfferBadgeText: getLtoEnabledOfferBadgeText(state, shortName),
    offerBadgeText: getOfferBadgeText(state, shortName)
  };
};

export default connect(mapStateToProps)(React.memo(OfferBox));
